<template>
    <div class="main-page">
        <div class="sales-land-page" v-if="salesCard != null && setup != null && saleItem != null">
            <navLand></navLand>
            <promoLand :cityProject="CityProject"></promoLand>
            <mainLand v-if="projectNameG != 'aqualina'"></mainLand>
            <aboutLand v-if="salesCard.project_land_site.about_init == 'true'" id="land-about" :class="{'yassytower-about' : salesCard.project_name.slug == 'yassy-tower'}"></aboutLand>
            <formLand :promoForm="CityProjectSales" class="top-form-yassytower" v-if="salesCard.project_name.slug == 'yassy-tower'"></formLand>

            <!-- new -->
            <aboutLandSecond v-if="salesCard.project_land_site.about_second_init == 'true'"></aboutLandSecond>
            <!-- end -->
            <locationLand v-if="salesCard.project_land_site.location_init == 'true' && salesCard.project_land_site.location_yandex_init == 'false'" id="land-location"></locationLand>
            <premsLand v-if="salesCard.project_land_site.prems_init == 'true'" id="land-prems"></premsLand>
            <!-- new -->
            <locationGalLand v-if="salesCard.project_land_site.location_yandex_init == 'true' && salesCard.project_land_site.location_second_init == 'true'" id="land-location"></locationGalLand>
            <locationYandexMap v-if="salesCard.project_land_site.location_yandex_init == 'true'"></locationYandexMap>
            <genplanLand v-if="salesCard.project_land_site.genplan_init == 'true'" id="land-genplan"></genplanLand>
            <archLand v-if="salesCard.project_land_site.arch_init == 'true'" id="land-arch"></archLand>
            <lobbiLand v-if="salesCard.project_land_site.lobbi_init == 'true'" id="land-lobbi"></lobbiLand>
            <fineFinishLand v-if="salesCard.project_land_site.fine_finish_init == 'true'" id="land-finefinish"></fineFinishLand>
            <aqualinaFlatsInfo v-if="salesCard.project_name.slug == 'aqualina'"></aqualinaFlatsInfo>
            <!-- end -->
            <formLand :promoForm="CityProjectSales"></formLand>

            <!-- Планировки ДЛЯ РАЗЛИЧНЫХ ОБЪЕКТОВ -->
            <CRMflats v-if="saleFilterParams != null && saleItem != null && salesCard.project_land_site.flats_init == 'true' && projectNameG != 'aqualina' && projectNameG != 'yassytower' && projectNameG == 'alfarabi27' || projectNameG == 'orion' || projectNameG == 'akvarel' || projectNameG == 'jazzkvartal' || projectNameG == 'auezovcity' || projectNameG == 'primavera' || projectNameG == 'austria' || projectNameG == 'estet' || projectNameG == 'qazyna' || projectNameG == 'shahristan' || projectNameG == 'soho2' || projectNameG == 'orion-3' || projectNameG == 'discovery' || projectNameG == 'aman'" id="land-flats"></CRMflats>
            <flatsLand v-if="salesCard.project_land_site.flats_init == 'true' && projectNameG != 'aqualina' && projectNameG != 'yassytower' && projectNameG != 'alfarabi27' && projectNameG != 'orion' && projectNameG != 'akvarel' && projectNameG != 'jazzkvartal' && projectNameG != 'auezovcity' && projectNameG != 'primavera' && projectNameG != 'kohota' && projectNameG != 'austria' && projectNameG != 'estet' && projectNameG != 'qazyna' && projectNameG != 'shahristan' && projectNameG != 'soho2' && projectNameG != 'orion-3' && projectNameG != 'discovery' && projectNameG != 'aman'" id="land-flats"></flatsLand>
            <aqualinaFlats v-if="salesCard.project_land_site.flats_init == 'true' && projectNameG == 'aqualina'" id="land-flats"></aqualinaFlats>
            <kohotaFlats v-if="salesCard.project_land_site.flats_init == 'true' && projectNameG == 'kohota'" id="land-flats"></kohotaFlats>
            <yassyTowerFlats  v-if="salesCard.project_land_site.flats_init == 'true' && projectNameG == 'yassytower'" id="land-flats"></yassyTowerFlats>
            <!-- Планировки ДЛЯ РАЗЛИЧНЫХ ОБЪЕКТОВ -->

            <galleryLand v-if="salesCard.project_land_site.gallery_init == 'true'" id="land-gallery"></galleryLand>
            <newsLand v-if="salesCard.project_land_site.news_init == 'true'" id="land-news"></newsLand>
            <formLand :promoForm="CityProjectSales" v-if="contactsSetup && salesCard.project_land_site.contacts_init == 'true'"></formLand>
            <contactsLand v-if="setup != null && contactsSetup && salesCard.project_land_site.contacts_init == 'true'" id="land-contacts"></contactsLand>
            <div class="container">
                <sharePostBottom :options="[{title: 'Поделиться ' + CapitalizeID(projectNameG) +  ':', data_title: CapitalizeID(projectNameG) + ' - ' + salesCard.project_title, data_link: 'https://' + projectNameG + '.bazis.kz', data_page: 'Sales_Land - ' + CapitalizeID(projectNameG), data_page_key: 'sales-land-page'}]" v-if="projectNameG != 'yassytower'"></sharePostBottom>
                <sharePostBottom :options="[{title: 'Поделиться ' + CapitalizeID(projectNameG) +  ':', data_title: CapitalizeID(projectNameG) + ' - ' + salesCard.project_title, data_link: 'https://' + projectNameG + '.kz', data_page: 'Sales_Land - ' + CapitalizeID(projectNameG), data_page_key: 'sales-land-page'}]" v-if="projectNameG == 'yassytower'"></sharePostBottom>
                <div class="rules-of-sales" v-if="salesCard != null && salesCardPage != null">
                    <p v-html="saleItem.project_zakon_desc" v-if="saleItem.project_zakon_desc != null"></p>
                    <p v-if="salesCardPage.land_footer_zakon_desc != null">{{salesCardPage.land_footer_zakon_desc}}</p>
                </div>
            </div>
        </div>
        <div class="global-overlay" :class="{'open' : isOpenSendwich, 'open' : isOpenSendwichMobile}" @click="closeMobileMenu(false)">
            <!-- <div class="global-overlay-ripple" :class="{animatedEnd: animatedEnd}"></div> -->
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import navLand from '@/components/sales-land-partials/land-nav.vue'
    import promoLand from '@/components/sales-land-partials/land-promo.vue'
    import mainLand from '@/components/sales-land-partials/land-main.vue'
    import aboutLand from '@/components/sales-land-partials/land-about.vue'
    import locationLand from '@/components/sales-land-partials/land-location.vue'
    import premsLand from '@/components/sales-land-partials/land-prems.vue'


    import flatsLand from '@/components/sales-land-partials/land-flats.vue'
    import CRMflats from '@/components/flats-crm/flats-crm-section.vue'
    

    import galleryLand from '@/components/sales-land-partials/land-gallery.vue'
    import newsLand from '@/components/sales-land-partials/land-news.vue'
    import contactsLand from '@/components/sales-land-partials/land-contacts.vue'
    import formLand from '@/components/forms/form-sales-land.vue'
    import sharePostBottom from '@/components/share/share-social-bottom.vue'
    import aboutLandSecond from '@/components/sales-land-partials/land-about-second.vue'
    import archLand from '@/components/sales-land-partials/land-arch.vue'
    import genplanLand from '@/components/sales-land-partials/land-genplan.vue'
    import lobbiLand from '@/components/sales-land-partials/land-lobbi.vue'
    import fineFinishLand from '@/components/sales-land-partials/land-finefinish.vue'
    import locationGalLand from '@/components/sales-land-partials/land-location-gal.vue'
    import locationYandexMap from '@/components/sales-land-partials/land-yandex-map.vue'
    import aqualinaFlatsInfo from '@/components/sales-land-partials/partials/aqualina-flats-info.vue'
    import aqualinaFlats from '@/components/sales-land-partials/partials/aqualina-flats.vue'
    import kohotaFlats from '@/components/sales-land-partials/partials/kohota-flats.vue'
    import yassyTowerFlats from '@/components/sales-land-partials/partials/yassytower-flats.vue'
    export default {
        name: 'main--page',
        components: {
            navLand,
            promoLand,
            mainLand,
            aboutLand,
            locationLand,
            premsLand,

            flatsLand,
            CRMflats,

            galleryLand,
            newsLand,
            contactsLand,
            formLand,
            sharePostBottom,
            // NEW SECTIONS
            aboutLandSecond,
            archLand,
            genplanLand,
            lobbiLand,
            fineFinishLand,
            locationGalLand,
            locationYandexMap,
            aqualinaFlatsInfo,
            aqualinaFlats,
            kohotaFlats,
            yassyTowerFlats,
        },
        data () {
            return {
                DomLoaded: false,
                iSmobile: false,

                CityProject: null,
                CityProjectSales: null,
                formInit: false,
                projectNameG: window.host,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            saleItem: 'loadSaleCardItem',
            saleFilterParams: 'loadSalesFilterCardParams',
            contactsSetup: 'loadContactsPage',

            banerSystem: 'loadBanerSystem',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',

            isOpenFormModal: 'loadisOpenFormModal',
            isOpenSendwich: 'loadIsOpenSendwich',
            isOpenSendwichMobile: 'loadIsOpenSendwichMobile',
        }),
        methods: {
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_sendwich_mobile', data);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
            removeLoaderPage() {
                var loader = document.getElementById('loader');
                loader.classList.remove("InitLoader");
                setTimeout(()=>{
                    loader.remove();
                },500);
            },
        },
        created () {
            // document.title = this.title;
            // window.addEventListener('scroll', this.handleScroll);
        },
        mounted() {
            this.isMobileCheck();
            this.checkResize();
        }
    }
</script>